import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";

export const useDeleteVideoSubmission = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (id: string) =>
            client.fetchApi<{ success: boolean; message: string }, {}>({
                endpoint: `video-submissions/${id}`,
                method: 'DELETE',
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['video-submissions', 'list', selectedOrganization?.id || ''] });
        },
    });
};
